import * as types from './actionTypes';

export function storeIdToken(idToken) {
    return dispatch => {
        return dispatch(dispatchIdToken(idToken));
    }
}

function dispatchIdToken(idToken) {
    return {type: types.IDTOKEN, idToken: idToken}
}

export function storeAccessToken(accessToken) {
    return dispatch => {
        return dispatch(dispatchAccessToken(accessToken));
    }
}

export function dispatchAccessToken(accessToken) {
    return {type: types.ACCESSTOKEN, accessToken: accessToken}
}


// WEBPACK FOOTER //
// ./src/service/authActions.js